import { render, staticRenderFns } from "./CustAdd.vue?vue&type=template&id=43b7e0e8&scoped=true&"
import script from "./CustAdd.vue?vue&type=script&lang=js&"
export * from "./CustAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b7e0e8",
  null
  
)

export default component.exports